import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { resolve, reject } from 'q';

import { environment } from "../../environments/environment";
import { encode } from 'punycode';
import { BehaviorSubject } from 'rxjs';
// import { AlertService } from './alert.service';

@Injectable()
export class CompanyService {
    constructor(private http: HttpClient) { };
    private il = new BehaviorSubject<string>('');
    inventory = this.il.asObservable();

    public getBussiness(data) {
        const getBussinessObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/company?page=${data.page}&offset=${data.offset}&orderby=${data.orderby}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getBussinessObservable; 
    } // prifle end*/
    public getCompany(company) {
        const getCompanyObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/company/${company}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getCompanyObservable; 
    } // prifle end*/
    public updateCompany(company){
        const updateUserObservable = new Observable(observer => {
            this.http.put(`${environment.API_HOST}/company/${company.code}`,company)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateUserObservable;  
    }
    public deleteCompany(company){
        const deleteCompanyObservable = new Observable(observer => {
            this.http.delete(`${environment.API_HOST}/company/${company.code}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return deleteCompanyObservable;  
    }
    public newCompany(company){
        const updateUserObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/company/`,company)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateUserObservable;  
    }
} // class

// Mon Apr 15 2019 13:33:13 GMT-0600